import { Script } from "gatsby"
import React, { useState, useEffect } from "react"

interface PlacesApiLoaderProps {
  children: React.ReactChild
}

const PlacesApiLoader = ({ children }: PlacesApiLoaderProps) => {
  useEffect(() => {
    // This function is required when loading the place api. Adding the empty function
    // here avoids the warning message in the browser console
    // https://developers.google.com/maps/documentation/javascript/overview#js_api_loader_package
    window.initMap = () => {
      return
    }
  })
  const [scriptLoaded, setScriptLoaded] = useState(false)
  return (
    <>
      <Script
        src={`https://maps.googleapis.com/maps/api/js?key=${
          process.env.GATSBY_GOOGLE_API_KEY ?? ""
        }&libraries=places&callback=initMap`}
        onLoad={() => setScriptLoaded(true)}
      />
      {scriptLoaded && children}
    </>
  )
}

export default PlacesApiLoader
